export default __webpack_public_path__ + "static/media/ls-maintenance-losses.d17b1abc.svg";